import React, { useState } from "react"
import { Box, TextField, Button, Typography, Grid, useTheme } from "@mui/material"
import useMutation from "../../../hooks/useMutation"

const getCustomColorSx = (theme) => ({
  "& .MuiInputLabel-root.Mui-focused": {
    color: theme.palette.start.main,
  },
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: theme.palette.start.main,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.start.main,
    },
  },
})

const ForgotPassword = () => {
  const [email, setEmail] = useState("")
  const [showInfo, setShowInfo] = useState(false)

  const theme = useTheme()

  const { mutate: resetMutation } = useMutation("/auth/resetpassword")

  const handleResetPW = async (event) => {
    event.preventDefault()

    setShowInfo(true)
    setEmail("")

    await resetMutation({ email })
  }

  return (
    <Grid container>
      <Grid item xs={1} md={4}>
        <Box></Box>
      </Grid>
      <Grid item xs={10} md={4}>
        <Box
          component="form"
          onSubmit={handleResetPW}
          noValidate
          sx={{
            mx: "auto",
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: "start.main",
            borderRadius: "12px",
            p: 3,
            width: "100%",
            mt: 3,
          }}>
          <Typography variant="h6" sx={{ color: "black" }}>
            Passwort zurücksetzen
          </Typography>
          <TextField
            margin="normal"
            disabled={showInfo}
            required
            fullWidth
            type="text"
            id="sendPW"
            name="sendPW"
            // autoFocus
            onChange={(e) => setEmail(e.target.value)}
            variant="outlined"
            label="Email"
            sx={{ backgroundColor: "white", height: "3.5rem", borderRadius: "0.3rem", ...getCustomColorSx(theme) }}
          />
          <Button
            type="submit"
            fullWidth
            disabled={!email.length || showInfo}
            sx={{ mt: 3, color: "white", backgroundColor: "start.main", height: "3.5rem" }}>
            Weiter
          </Button>

          {showInfo && (
            <Typography variant="body1" sx={{ mt: 2 }}>
              Falls ein Account mit dieser Email-Adresse existiert, wird in Kürze eine E-Mail mit weiteren Anweisungen versendet.
            </Typography>
          )}
        </Box>
      </Grid>
      <Grid item xs={1} md={4}>
        <Box></Box>
      </Grid>
    </Grid>
  )
}

export default ForgotPassword
